import React, { FC } from "react";
import { Box, Divider, Stack } from "@mui/material";
import { Link } from "gatsby-theme-material-ui";

import { MenuLink } from "@src/types";
import { camelize } from "@src/utils";

import { Colors } from "@theme/colors";
import HeaderSubMenu from "./submenu";

interface Props {
  link: MenuLink;
}

const MobileNav: FC<Props> = ({ link }) => {
  const textColor = Colors.TextPrimary;
  const activeColor = { color: Colors.InfoMain };

  const linkStyle = {
    color: textColor,
    fontSize: "15px",
    fontWeight: "600",
    lineHeight: "24px",
    textDecoration: "none",
  };

  if (link.type === "submenu" && link?.subSections?.length > 0) {
    return (
      <Stack
        sx={{
          gap: "16px",
        }}
      >
        {link.subSections
          .filter((item) => {
            if (item?.layout === "highlight") {
              return false;
            }

            return true;
          })
          .map((item) => {
            const linkId = `link-${camelize(link.name)}`;

            if (item.mobile !== "bottom")
              return (
                <HeaderSubMenu
                  key={linkId}
                  title={item.name}
                  menuLinks={item.menuLinks}
                  accentColorKey={item.accentColor ? item.accentColor : ""}
                  footerMenu={true}
                />
              );
          })}
        {link.subSections.map((item) => {
          const linkId = `link-${camelize(link.name)}`;

          if (item.mobile === "bottom")
            return (
              <HeaderSubMenu
                key={linkId}
                title={item.name}
                menuLinks={item.menuLinks}
                accentColorKey={item.accentColor ? item.accentColor : ""}
                footerMenu={true}
              />
            );
        })}
        <Divider light={true} sx={{ marginBottom: "16px" }} />
      </Stack>
    );
  } else if (link.type === "dropdown" && link.menuLinks?.length > 0) {
    return (
      <>
        {link.menuLinks?.map((item) => {
          return (
            <Box mb="16px" key={item.link}>
              <Link to={item.link} style={linkStyle}>
                {item.name}
              </Link>
            </Box>
          );
        })}
      </>
    );
  } else if (link.type === "internal") {
    return (
      <Box mb="16px">
        <Link to={link.link} style={linkStyle}>
          {link.name}
        </Link>
      </Box>
    );
  } else if (link.type === "external") {
    return (
      <Box mb="16px">
        <a href={link.link} target="_blank" style={linkStyle}>
          {link.name}
        </a>
      </Box>
    );
  } else {
    return <span style={linkStyle}>{link.name}</span>;
  }
};

export default MobileNav;
